// extracted by mini-css-extract-plugin
export default {"container":"PollAttachmentIcon_container__6tZ+R","icon":"PollAttachmentIcon_icon__rPFQ3","image":"PollAttachmentIcon_image__CL-48"};